import type { Incident, IncidentListItem, Position } from '@/signalr/contracts';

export type IncidentListRow = {
  id: string;
  title: string;
  createdTimeUtc: string;
  lastPosition: Position | null;
  psapNames: readonly string[];
  incidentLabel: string | null;
};

export function toRowFromIncident(incident: Incident): IncidentListRow {
  return {
    id: incident.id,
    title: incident.title,
    createdTimeUtc: incident.createdTimeUtc,
    lastPosition: incident.lastPosition,
    psapNames: incident.involvedPsaps.filter((psap) => psap.isActive).map((psap) => psap.displayName),
    incidentLabel: incident.additionalIncidentData.incidentLabel,
  };
}

export function toRowFromArchivedIncident(item: IncidentListItem): IncidentListRow {
  return {
    id: item.id,
    title: item.title,
    createdTimeUtc: item.createdTime,
    lastPosition: item.lastPosition,
    psapNames: (item.psaps ?? []).map((psap) => psap.displayName),
    incidentLabel: item.incidentLabel ?? null,
  };
}
